import { isRSAA, RSAA } from 'redux-api-middleware';
import { selectors } from '../config';

const authHeaderMiddleware = store => next => action => {
  if (!isRSAA(action)) {
    return next(action);
  }

  const accessToken = selectors.accessToken(store.getState());
  if (!accessToken) {
    return next(action);
  }

  return next({
    ...action,
    [RSAA]: {
      ...action[RSAA],
      headers: {
        ...action[RSAA].headers,
        Authorization: `Bearer ${accessToken}`
      }
    }
  });
};

export default authHeaderMiddleware;
